export default __webpack_public_path__ + "static/media/body-gradient-bg-mobile.7330a9a0.jpg";